import React, { Component, Fragment } from "react";
import withAppData from "../../HOC/withAppData";
import withDataLog from "../../HOC/withDataLog";
import { _cloneArray, _findArray } from "../../Utils/helpers";
import "../../Styles/Pages/addressbook.scss";
import ImageTagSteps from "../Tools/ImageTagSteps";
import WebRtcCamera from "../../Resources/WebRtcCamera";

class OutletPhoto extends Component {
	constructor(props) {
		super(props);
		this.customerPictureRef = React.createRef();
		this.state = {
			tempImageUrl: "",
			addedImages: [],
			imageTagsGuides: [],
			showImageTagging: false,
			pictureError: "upload an image",
			customerPicture: {},
			hasUploadedPicture: false,
			customerId: "",
			customerName: "",
		};
	}
	showPictureError = flag => {
		this.setState(
			{
				pictureError:
					flag === 2 ? `Add all required pictures` : "Please upload a picture",
			},
			() => {
				this.customerPictureRef.current &&
					this.customerPictureRef.current.scrollIntoView();
			},
		);
	};
	checkGuideDoneCount = () => {
		let imageTagsGuides = _cloneArray(this.state.imageTagsGuides);
		imageTagsGuides.forEach(guide => {
			if (!guide.done) {
				guide.showError = true;
			}
		});
		this.setState({ imageTagsGuides });
		return imageTagsGuides.length === 0
			? true
			: _findArray(imageTagsGuides, "showError", true)
			? false
			: true;
	};
	uploadImages = e => {
		if (e && e.target && e.target.files) {
			let files = e.target.files;
			if (files && files.length > 0) {
				let tempImageUrl = window.URL.createObjectURL(files[0]);
				this.setState({ tempImageUrl, tempFile: files[0] }, () => {
					if (1) {
						if ((this.props.imageTagData.imageTags || []).length > 0) {
							this.props.setShowImageTagging(true, tempImageUrl, 0);
						} else {
							this.props.addImages();
						}
					} else {
						this.setState({
							customerPicture: { file: this.state.tempFile, url: tempImageUrl },
						});
					}
				});
			}
		}
	};
	webUploadImages = files => {
		if (files) {
			if (files) {
				let tempImageUrl = window.URL.createObjectURL(files);
				this.setState({ tempImageUrl, tempFile: files }, () => {
					if (1) {
						if ((this.props.imageTagData.imageTags || []).length > 0) {
							this.props.setShowImageTagging(true, tempImageUrl, 0);
						} else {
							this.props.addImages();
						}
					} else {
						this.setState({
							customerPicture: { file: this.state.tempFile, url: tempImageUrl },
						});
					}
				});
			}
		}
	};
	render() {
		const addedImages = this.props.imageTagData
			? this.props.imageTagData.addedImages || []
			: [];
		const imageTagsGuides = this.props.imageTagData
			? this.props.imageTagData.imageTagsGuides || []
			: [];
		return (
			<Fragment>
				<ImageTagSteps guides={imageTagsGuides} />
				<div className="default-contact-images" style={{ margin: "8px 0" }}>
					{this.props.isDriver && addedImages.length < 3 && (
						<div style={{ width: "180px" }}>
							<WebRtcCamera
								savePicture={file => this.webUploadImages(file)}
								labelWidth={"180px"}
								labelHeight={"120px"}
								// facingMode={"user"}
							/>
						</div>
					)}
					{!this.props.isDriver && (
						<>
							{addedImages.length < 3 && (
								<>
									<input
										type="file"
										accept="image/*"
										className="hide"
										id="default-contact-images-upload"
										onChange={this.uploadImages}
										capture="environment"
									/>
									<div
										className="relative"
										style={{
											width: this.props.width && this.props.width,
											border: "1px dashed #D4D5D8",
											height: "120px",
											background: " #fafafa",
										}}
									>
										<label
											className="default-contact-images-add"
											htmlFor={"default-contact-images-upload"}
											style={{
												border:
													this.props.showPictureError && addedImages.length < 3
														? "1px solid red"
														: "",
											}}
										>
											<div>
												<img
													src="Images/camera.png"
													style={{ opacity: 0.6 }}
													alt=""
												/>
												<p style={{ textAlign: "center" }}>Upload Photo</p>
												{this.props.showPictureError && (
													<span className="picture-error"></span>
												)}
											</div>
										</label>
									</div>
								</>
							)}
						</>
					)}
					{addedImages.map((image, i) => (
						<div key={i} className="default-contact-images-each">
							<img src={image.url} alt="" />
							<span
								onClick={() =>
									this.props.imageTagData.removeAddedImage(i, image)
								}
							>
								&times;
							</span>
							{image.tagName && <p>{image.tagName}</p>}
						</div>
					))}
				</div>
			</Fragment>
		);
	}
}

export default withAppData(withDataLog(OutletPhoto));
